// reducers/case/create_case.js
import { CREATE_CASE, RETRIEVE_CASE_ADMIN, GET_ALL_CASE, CANCEL_CASE_BY_ADMIN, UPDATE_CATE_BY_ADMIN, GET_ALL_CASE_VALIDATE, UPDATE_CASE_PRIORITY } from '../../actions/types';

const initialState = [];

function create_caseReducer(create_case = initialState, action) {
    const { type, payload } = action;
    switch (type) {
        case CREATE_CASE:
            return [...create_case, payload];
        case RETRIEVE_CASE_ADMIN:
        case GET_ALL_CASE:
        case GET_ALL_CASE_VALIDATE:
            return payload;
        case CANCEL_CASE_BY_ADMIN:
        case UPDATE_CATE_BY_ADMIN:
            return create_case.map((item) => {
                if (item.Case_id === payload.Case_id) {
                    return {
                        ...item,
                        ...payload,
                    };
                } else {
                    return item;
                }
            });
        case UPDATE_CASE_PRIORITY:
            if (!payload || !payload.priority_update_log) {
                return create_case;
            }

            const { case_id, new_priority_id } = payload.priority_update_log;

            return create_case.map((item) => {
                if (item.Case_id === case_id) {
                    return {
                        ...item,
                        priority_id: new_priority_id,
                    };
                } else {
                    return item;
                }
            });
        default:
            return create_case;
    }
}

export default create_caseReducer;
